import type { ReactNode } from 'react';
import { cn } from './cn';
import Eyebrow from './Eyebrow';
import BrandPattern from './BrandPattern';
import Reveal from './Reveal';

type Props = {
  eyebrow?: string;
  heading?: ReactNode;
  headingLevel?: 'h1' | 'h2';
  background?: 'white' | 'surface' | 'charcoal';
  pattern?: 'top-right' | 'bottom-right' | 'bottom-left' | 'none';
  children?: ReactNode;
  className?: string;
};

const bg = { white: 'bg-white text-black', surface: 'bg-surface text-black', charcoal: 'bg-charcoal text-white' };

/** Cadre de page: fond, espacement, eyebrow, titre et motif décoratif. */
export default function Section({ eyebrow, heading, headingLevel = 'h2', background = 'white', pattern = 'none', children, className }: Props) {
  const dark = background === 'charcoal';
  const H = headingLevel;
  return (
    <section className={cn('relative overflow-hidden py-16 md:py-24', bg[background], className)}>
      {pattern !== 'none' && <BrandPattern variant={pattern} />}
      <div className="site-container relative">
        {(eyebrow || heading) && (
          <Reveal className="mb-10 max-w-4xl md:mb-14">
            {eyebrow && <Eyebrow tone={dark ? 'light' : 'dark'} className="mb-4">{eyebrow}</Eyebrow>}
            {heading && (
              <H className="text-inherit font-display text-[2rem] font-bold normal-case leading-[1.1] tracking-normal md:text-[3rem]">
                {heading}
              </H>
            )}
          </Reveal>
        )}
        {children}
      </div>
    </section>
  );
}
